import { Crown, FlaskConical } from "lucide-react";
import { ORDER_STATUS, SHOP_STATUS, SUB_STATUS } from "@/lib/api";

export const DemoBadge = ({ className = "" }) => (
  <span data-testid="demo-badge" className={`inline-flex items-center gap-1 rounded-full bg-indigo-50 px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide text-indigo-700 ring-1 ring-indigo-200 ${className}`}>
    <FlaskConical className="h-3 w-3" /> Démo
  </span>
);

export const PremiumBadge = ({ className = "" }) => (
  <span data-testid="premium-badge" className={`inline-flex items-center gap-1 rounded-full bg-amber-400 px-2 py-0.5 text-[10px] font-extrabold uppercase tracking-wide text-amber-950 ${className}`}>
    <Crown className="h-3 w-3" /> Premium
  </span>
);

const ORDER_COLORS = {
  recue: "bg-orange-50 text-orange-700 ring-orange-200",
  confirmee: "bg-sky-50 text-sky-700 ring-sky-200",
  preparation: "bg-amber-50 text-amber-800 ring-amber-200",
  expediee: "bg-green-50 text-green-800 ring-green-200",
  annulee: "bg-gray-100 text-gray-600 ring-gray-200",
  pending: "bg-amber-50 text-amber-800 ring-amber-200",
  approved: "bg-green-50 text-green-800 ring-green-200",
  active: "bg-green-50 text-green-800 ring-green-200",
  payment_verified: "bg-sky-50 text-sky-700 ring-sky-200",
  rejected: "bg-red-50 text-red-700 ring-red-200",
  suspended: "bg-red-50 text-red-700 ring-red-200",
  expired: "bg-gray-100 text-gray-600 ring-gray-200",
  published: "bg-green-50 text-green-800 ring-green-200",
  draft: "bg-gray-100 text-gray-700 ring-gray-200",
  hidden_by_admin: "bg-red-50 text-red-700 ring-red-200",
};
const PRODUCT_STATUS = { published: "Publié", draft: "Brouillon", hidden_by_admin: "Masqué (admin)" };

export const StatusBadge = ({ status, kind = "order", testid }) => {
  const label = { order: ORDER_STATUS, shop: SHOP_STATUS, sub: SUB_STATUS, product: PRODUCT_STATUS }[kind]?.[status] || status;
  return (
    <span data-testid={testid || `status-${status}`} className={`inline-flex rounded-full px-2.5 py-0.5 text-xs font-semibold ring-1 ${ORDER_COLORS[status] || ORDER_COLORS.draft}`}>
      {label}
    </span>
  );
};
